import { Icon } from '@iconify/react/dist/iconify.js'
export default function PopUpConfirmRecallBookBorrow({ onConfirm, onClose }) {
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/50">
      <div className="z-50 flex h-[400px] w-[450px] flex-col items-center justify-center gap-2 rounded-[10px] bg-white shadow-lg">
        <div>
          <Icon
            icon="material-symbols:warning-outline-rounded"
            className="p-3 text-7xl text-[#A10000]"
          />
        </div>
        <p className="p-2 pb-0 pt-0 text-xl font-bold text-[#A10000]">
          Xác nhận thu hồi ?
        </p>
        <p className="p-2 pt-0 text-lg font-bold">
          Sách đã thu hồi không thể hoàn tác
        </p>
        <button
          onClick={onConfirm}
          className="h-12 w-[60%] rounded-lg bg-[#A10000] p-2 text-lg font-bold text-white"
        >
          Xác nhận
        </button>
        <button onClick={onClose} className="p-2 text-lg font-bold underline">
          Hủy
        </button>
      </div>
    </div>
  )
}
